import { Typography } from '@material-ui/core'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { setCurrentSiteId } from '../../AppRedux/actions/Applications'

import { useStyles } from './styles'
const SiteButton = (props) => {
  const classes = useStyles()
  const { index, selectIndex, selectedIndex, siteId } = props
  useEffect(() => {
    if (index === selectedIndex) props.setCurrentSiteId(siteId)
  }, [index, selectedIndex])
  return (
    <div
      className={
        classes.layout +
        (index === selectedIndex ? ' ' + classes.highlight : '')
      }
      onClick={() => {
        selectIndex(index)
      }}
    >
      <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
        {siteId}
      </Typography>
    </div>
  )
}
const mapDispatchToProps = (dispatch) => ({
  setCurrentSiteId: (payload) => dispatch(setCurrentSiteId(payload)),
})
export default connect(null, mapDispatchToProps)(SiteButton)
